export const diagnosticDashboard = {
  todo: {
    containerHeading: "Your to-do's",
    empty:
      "You're all set, your test results will be ready 2-3 days after your appointment!",
  },
  labTest: {
    containerHeading: "Your Tests",
    viewAll: "View all tests",
    status: {
      pending: "Test pending",
      completed: "Results ready",
    },
    statusMessage: {
      pending: "Waiting to process",
      created: "Order received",
      assigned: "In progress at lab",
      denied: "Unable to process",
      rejected: "Sample rejected",
      cancelled: "Order cancelled",
      completed: "Your results are ready!",
    },
  },
  consultation: {
    containerHeading: "Your Consultations",
    viewAll: "View all consultations",
    videoConferencing: "Web conferencing details will be emailed",
    asyncVisit: "A doctor will text you to review your results.",
    viewResults: "View my results",
    scheduleNurse: "Review with a nurse",
    scheduleDoctor: "Review with a doctor",
    buttons: {
      assigned: "Schedule consultation",
      scheduled: "View consultation",
      completed: "View consultation",
      canceled: "Reschedule consultation",
      no_show: "Reschedule consultation",
      editConsultation: "Edit consultation",
      viewConsultation: "View consultation",
    },
    status: {
      scheduled: "Scheduled",
      rescheduled: "Rescheduled",
      canceled: "Canceled",
      completed: "Completed",
      no_show: "No Show",
    },
  },
  signIn: {
    pageTitle: "Fertility Planning Health Dashboard",
    noAccount: "Don't have an account? ",
    getStarted: "Get started here",
    emailLabel: "Email",
    continueButton: "Continue",
    instructions:
      "Enter the email you used to purchase your test. You will receive a sign in link by email.",
    validation: {
      invalidEmail: "Invalid email address",
      required: "Required",
    },
    errors: {
      failedToSend: "Failed to send magic link. Please try again.",
      genericError: "An error occurred. Please try again later.",
    },
    success: {
      checkEmail: "Check your email",
      sentTo: "We've sent a magic link to",
      clickLink:
        "Click the link in your email to sign in to your diagnostic dashboard.",
    },
  },
  signOut: {
    buttonText: "Sign Out",
  },
  intake: {
    pageTitle: "Fertility Consultation Intake Form",
    heading: "Fertility Consultation Intake",
    subheading:
      "Please answer these quick questions so your doctor can review them together with your results.",
    questions: {
      tryingToConceive: {
        label: "How long have you been trying to conceive?",
        placeholder: "Select an answer",
        options: {
          notYetSoon:
            "Haven't started yet, planning to start in the next few months",
          notYetNotSoon:
            "Haven't started yet, not planning to start anytime soon",
          oneToSix: "1–6 months",
          sixToTwelve: "6–12 months",
          moreThanTwelve: "More than 12 months",
        },
      },
      lastMenstrualPeriod: {
        label: "What was the first day of your last menstrual period (LMP)?",
        helpText: "(This helps us better interpret your lab results)",
      },
      regularPeriods: {
        label: "Do you currently have regular menstrual periods?",
        placeholder: "Select an answer",
        options: {
          regular: "Yes, regularly every 24–35 days",
          mildlyIrregular: "Mildly irregular",
          irregular: "No, absent or highly irregular (>90 days)",
        },
      },
      cycleLength: {
        label: "How long is your typical cycle?",
        helpText:
          "(From Day 1 of one period to Day 1 of the next - not the number of days you bleed)",
        placeholder: "e.g., 28 days",
      },
      consent: {
        label: "Consent (Truthfulness):",
        disclaimer:
          "Please attest to the following confirming that all information you have provided to us is true and complete.",
        terms:
          "I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.",
        checkbox:
          "I have read the above information and I do consent and wish to move forward",
      },
      mensTryingToConceive: {
        label: "How long have you been trying to conceive?",
        placeholder: "Select an option",
        options: {
          notStartedCurious:
            "Haven't started yet, just curious about my fertility potential",
          notStartedSoon:
            "Haven't started yet, planning to start in the next few months",
          oneToSix: "I've been trying somewhere between 1–6 months",
          sixToTwelve: "I've been trying somewhere between 6–12 months",
          moreThanYear: "I've been trying for more than a year",
          notTrying:
            "Not trying at all, checking testosterone for other reasons",
        },
      },
      fatheredChildren: {
        label: "Have you successfully fathered a child in the past?",
        placeholder: "Select an option",
        options: {
          no: "No, I do not have any known children",
          yes: "Yes, I have children",
        },
      },
      currentSymptoms: {
        label:
          "Do you currently experience any of the following symptoms: (select all that apply)",
        options: {
          fatigue: "Fatigue",
          weightGain: "Weight Gain",
          decreasedLibido: "Decreased libido",
          erectileDysfunction: "Erectile dysfunction",
          depression: "Depression",
          none: "None of these apply",
        },
      },
      medicalHistory: {
        label: "Do any of the following apply to you (select all that apply):",
        options: {
          smoking: "I smoke, vape, or use other tobacco products",
          marijuana: "I use marijuana or other THC products regularly",
          opioids: "I use opioid medications regularly",
          testicularInfection:
            "I have a history of a testicular infection such as orchitis or epididymitis",
          sti: "I have a history of chlamydia, gonorrhea, and/or tuberculosis",
          undescendedTesticles:
            "I have a history of undescended testicles during my youth",
          testicularTrauma:
            "I have a history of testicular trauma/injury or surgery",
          radiation:
            "I have a history of full body radiation exposure for treatment of cancer",
          heatExposure:
            "I'm regularly exposed to heat such as sauna, hot tubs, or heated seats",
          testosterone:
            "I'm currently or recently have used testosterone supplements",
          none: "None of these apply to me",
        },
      },
      additionalQuestions: {
        label:
          "What other information or questions do you have for the doctor?",
        placeholder: "Type your questions or concerns here...",
      },
    },
    validation: {
      tryingToConceiveRequired:
        "Please select how long you've been trying to conceive",
      lastMenstrualPeriodRequired:
        "Please enter the first day of your last menstrual period",
      regularPeriodsRequired: "Please answer about your menstrual regularity",
      cycleLengthRequired: "Please enter your typical cycle length",
      consentRequired: "You must consent to continue with the service",
      fatheredChildrenRequired: "Please select an option",
      currentSymptomsRequired: "Please select an option",
      medicalHistoryRequired: "Please select an option",
    },
    submitButton: "Continue",
    errorMessage:
      "We weren't able to book your consultation. Please ensure the form is complete and try again.",
    errorHeading: "Unable to Load Intake Form",
    errorDescription:
      "We're having trouble loading your intake form. This may be temporary. Please try again or contact support if the issue continues.",
    backToDashboard: "Back to Dashboard",
    intakecomplete: {
      pageTitle: "Consultation Intake Complete",
      heading: "You're all set!",
      subheading:
        "Thanks for completing your intake. Our partner doctor will review your results with you by secure text, and a Conceive nurse will follow up to support you with guidance and next steps.",
      whatsNext: "What's next?",
      step1: {
        title: "Chat with a doctor about your results",
        description:
          "Our partner doctor will reach out by text to review and interpret your results.",
      },
      step2: {
        title: "Next steps and guidance with your Conceive nurse",
        description:
          "Your Conceive nurse will follow up to answer questions and guide your next steps.",
      },
      goToDashboard: "Return to my dashboard",
    },
  },
  confirmation: {
    heading: "Your order is confirmed!",
    defaultSubheading:
      "Thank you for purchasing the {{productName}}! Next, schedule your appointment at a nearby lab.",
    subheading: {
      womens_basics:
        "Thank you for purchasing the Women's Basic Fertility Test! Next, schedule your appointment between days 2-4 of your cycle (day 1 being the first day of your period) at a nearby lab.",
      womens_advanced:
        "Thank you for purchasing the Women's Advanced Fertility Test! Next, schedule your appointment between days 2-4 of your cycle (day 1 being the first day of your period) at a nearby lab.",
      mens_basics: "Thank you for purchasing the Semen Analysis test.",
      mens_advanced:
        "Thank you for purchasing the Men's Advanced Fertility Test!",
    },
    bookAppointment: "Book appointment",
    whatsNext: "What's next?",
    step1Title: "Schedule your appointment.",
    step1Description: "Take your test at a nearby lab.",
    step1: {
      womens_basics: {
        title: "Schedule your appointment.",
        description:
          "Take your test at a nearby lab between days 2-4 of your cycle (day 1 being the first day of your period).",
      },
      womens_advanced: {
        title: "Schedule your appointment.",
        description:
          "Take your test at a nearby lab between days 2-4 of your cycle (day 1 being the first day of your period).",
      },
      mens_basics: {
        title: "Receive your kit.",
        description:
          "You will receive an email from our partner, Legacy, once your kit ships.",
      },
      mens_advanced: {
        title: "Receive your kit and schedule your appointment.",
        description:
          "For Semen Analysis, you will receive an email from our partner, Legacy, once your at-home kit ships. For your bloodwork, follow the instructions in your confirmation email to schedule a visit at a nearby lab.",
      },
    },
    step2Title: "Receive your results in 2-3 days after taking your test.",
    step2Description: "Check for the status of your results on this page.",
    step2: {
      mens_basics: {
        title: "Collect your sample.",
        description:
          "Follow the instructions provided by Legacy to register your kit, collect your sample, and prepare it for shipping.",
      },
      mens_advanced: {
        title: "Collect your sample.",
        description:
          "Follow the instructions provided by Legacy to register your kit, collect your sample, and prepare it for shipping.",
      },
    },
    step3Title: "Review your results.",
    step3Description:
      "Bring your results to your provider or book a consultation with one of our certified OBGYNs.",
    step3: {
      mens_basics: {
        title: "Ship the kit back.",
        description:
          "Use the prepaid overnight shipping label included in your kit.",
      },
      mens_advanced: {
        title: "Ship the kit back.",
        description:
          "Use the prepaid overnight shipping label included in your kit.",
      },
    },
    step4: {
      mens_basics: {
        title: "Review your results.",
        description:
          "We'll email you as soon as your results are available in your Conceive dashboard. Bring your results to your provider or book a consultation with one of our physicians.",
      },
      mens_advanced: {
        title: "Review your results.",
        description:
          "We'll email you as soon as your results are available in your Conceive dashboard. Bring your results to your provider or book a consultation with one of our physicians. You'll receive your blood test results 2-3 days after taking your blood tests in the lab.",
      },
    },
    goToDashboard: "Go to your dashboard",
  },
  patientForm: {
    heading: "You're on your way to getting insight into your fertility!",
    subheading:
      "Please complete the form for our health providers in order to purchase your test.",
    patientInfo: "Patient Information",
    contactInfo: "Contact Information",
    clinicType: "OB Clinic or REI Clinic",
    addressInfo: "Address Information",
    hipaaConsent:
      "I confirm that I have read and agree to the terms of the <HIPAALink>HIPAA authorization</HIPAALink>",
    termsConsent:
      "I accept Conceive's <TermsLink>Terms of Service</TermsLink> and <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.",
    continueToCheckout: "Continue to checkout",
    facilityFinder: {
      heading: "Let's find a lab near you",
      zipCodeLabel: "ZIP Code",
      zipCodePlaceholder: "Enter ZIP code",
      radiusLabel: "Radius",
      radiusOptions: {
        ten: "10 miles",
        twenty: "20 miles",
        twentyFive: "25 miles",
        fifty: "50 miles",
      },
      errorFetchingFacilities:
        "Unable to fetch facilities at this time. Please try again later.",
      noFacilitiesFoundTitle:
        "No lab locations found within {{radius}} miles of {{postalCode}}",
      noFacilitiesFoundDescription:
        "Try increasing your search radius or verifying your ZIP code.",
      locationsFoundNear: "We found {{count}} lab location nearby.",
      locationsFoundNear_other: "We found {{count}} lab locations nearby.",
      phoneLabel: "Phone:",
      faxLabel: "Fax:",
      summaryMessage:
        "There is <strong>{{count}}</strong> lab location nearby. You can complete your Conceive Assess lab work at any of them.",
      summaryMessage_other:
        "There are <strong>{{count}}</strong> lab locations nearby. You can complete your Conceive Assess lab work at any of them.",
      continueButton: "Continue",
      validation: {
        postalCodeRequired: "Postal code is required",
        postalCodeInvalid: "Postal code must be exactly 5 digits",
        radiusRequired: "Radius is required",
      },
    },
    labels: {
      firstName: "First name",
      lastName: "Last name",
      gender: "Gender",
      dateOfBirth: "Date of Birth",
      email: "Email",
      emailHint:
        "This email will be used to access your appointments and test results.",
      phoneNumber: "Phone number",
      streetAddress: "Street address",
      apartment: "Apartment, suite, etc. (optional)",
      city: "City",
      state: "State",
      postalCode: "Postal code",
      country: "Country",
    },
    placeholders: {
      firstName: "First name",
      lastName: "Last name",
      selectGender: "Select gender",
      dateOfBirth: "MM / DD / YYYY",
      email: "Email",
      phoneNumber: "(555) 123 - 4567",
      selectClinic: "Select clinic type",
      streetAddress: "Street address",
      apartment: "Apartment, suite, etc.",
      city: "City",
      state: "State",
      postalCode: "Postal code",
      selectCountry: "Select country",
    },
    options: {
      female: "Female",
      male: "Male",
      unitedStates: "United States",
    },
    validation: {
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      genderRequired: "Gender is required",
      invalidEmail: "Invalid email address",
      emailRequired: "Email is required",
      streetAddressRequired: "Street address is required",
      cityRequired: "City is required",
      stateRequired: "State is required",
      postalCodeRequired: "Postal code is required",
      countryRequired: "Country is required",
      hipaaRequired: "You must agree to HIPAA authorization",
      termsRequired: "You must agree to the Terms of Use",
    },
  },
  resources: {
    title: "Resources to help you get started",
    description:
      "Curious about your fertility but don't know where to start? Trying for a while but haven't had success? We've got you covered.",
  },
  support: {
    title: "Support whenever you need it",
    description:
      "Think of Conceive as your fertility concierge: We can help you get real answers and seen by the doctors you need.",
    cta: "Join now",
  },
  orderTests: {
    title: "Order Additional Tests",
    sections: {
      men: {
        title: "Testing for Men",
        products: {
          mens_basics: {
            tagline: "SEMEN ANALYSIS",
            description:
              "Understanding sperm health is a key part of the fertility journey. Whether you're actively trying or just want clarity for the future, this test gives you important insights into your fertility.",
          },
          mens_advanced: {
            tagline: "Mens Advanced",
            description:
              "Understanding sperm health is a key part of the fertility journey. Whether you're actively trying or just want clarity for the future, this test gives you important insights into your fertility.",
          },
        },
      },
      women: {
        title: "Testing for Women",
        products: {
          womens_basics: {
            tagline: "JUST GETTING STARTED",
            description:
              "Designed for those early in their fertility journey, this test offers key insights into your reproductive health and potential next steps.",
          },
          womens_advanced: {
            tagline: "WANT MORE INSIGHTS?",
            description:
              "Dive deeper into your fertility with comprehensive hormonal analysis, perfect for those actively planning pregnancy.",
          },
        },
      },
      support: {
        title: "For Extra Support",
        products: {
          ovulation_support: {
            tagline: "CONCEIVING WITH TIMED INTERCOURSE",
            description:
              "For those that can't stand OPKs and want a better understanding of their menstrual cycle and when they will ovulate.",
          },
          pregnancy_support: {
            tagline: "KNOW FOR SURE",
            description:
              "Confirm pregnancy accurately and early with a blood test.",
          },
        },
      },
    },
    buttonText: "Buy now",
  },
  understandingResults: {
    heading: "Need help understanding your results?",
    description:
      "Want to better understand your blood test results? Book an appointment with a fertility nurse to provide guidance and more.",
    benefits: {
      insights: "Clear and meaningful insights, without the scientific jargon.",
      interpretation:
        "Interpretation of your results and how it impacts your fertility.",
      nextSteps: "Work with a fertility nurse to get actionable next steps.",
    },
    learnMore: "Schedule now",
  },
  faq: {
    heading: "FAQ's",
    items: [
      {
        question: "What guidance will I get along with my results?",
        answer:
          "You will receive a detailed report with your lab results and what they mean. You will also be able to schedule a telehealth consultation to discuss your results and any next steps with a fertility doctor.",
      },
      {
        question: "What steps should I take after receiving my test results?",
        answer:
          "You can schedule a telehealth consultation with a fertility doctor to review your results and come up with a fertility plan. If you are ready to start trying, or are already trying, and you would like ongoing support from our fertility nurses and coaches, you can sign up for Conceive through our website weconceive.com.",
      },
      {
        question: "How long will the results take to come back?",
        answer:
          "You should have your results back within 5 business days. If you haven't received them by then, please email us at testing@weconceive.com.",
      },
      {
        question:
          "Can Conceive help if I already have a known fertility issue? (or if i have already done this testing)",
        answer:
          "Yes! If you want to re-do any of these tests, or there are any you haven't done, you can go ahead and order them through here. If you are unsure of what testing you might need, you can also start out by scheduling a telehealth consultation with a fertility doctor.",
      },
    ],
  },
};
